<template>
  <div>
    <b-modal :ref="id" :id="id" :title="$t('account.delete-option.title')" scrollable size="lg" title-class="font-18" v-model="show" @hidden="onHide">
      <div>
        <b-alert show variant="primary">
          <span v-html="$t('account.delete-option.description', { account: account.name })"></span>
        </b-alert>

        <b-form-checkbox v-model="payload.options.handoverToHeir" switch class="mb-2"> {{ $t("account.delete-option.handover-to-heir") }}</b-form-checkbox>

        <div v-if="payload.options.handoverToHeir">
          <sweet-input
            v-model="payload.options.heir"
            :isValid="!$v.payload.options.heir.$error"
            :placeholder="$t('common.email')"
            @input="$v.payload.options.heir.$touch()"
            type="text"
            layout="vertical"
            inputClass="mb-1"
          />
        </div>

        <div v-if="strict">
          <hr class="m-4" />
          <span v-html="$t('account.delete-option.repeat', { email: account.credential.email })" class="text-danger"></span>

          <sweet-input v-model="repeat" :isValid="!$v.repeat.$error" @input="$v.repeat.$touch()" type="text" layout="vertical" inputClass="mb-1" />
        </div>
        <sweet-button @click="remove()" :disabled="isDisabled" :loading="isUpdating" variant="danger" icon="mdi mdi-delete" :block="true">
          <span v-html="$t('account.delete-option.delete', { account: account.name })"></span>
        </sweet-button>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="ml-2">
            {{ $t("common.cancel") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { email, required, sameAs } from "vuelidate/lib/validators";
export default {
  props: ["id", "account", "strict"],
  data() {
    return {
      payload: { options: { handoverToHeir: false, heir: null } },
      show: false,
      repeat: undefined,
    };
  },
  validations: {
    repeat: {
      sameAs: sameAs(function(value) {
        if (!this.strict) return true;
        return this.account.credential.email;
      }),
    },

    payload: {
      options: {
        heir: {
          required,
          email,
        },
      },
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["account/isLoading"];
    },
    isUpdating() {
      return this.$store.getters["account/isUpdating"];
    },
    isDisabled() {
      return this.isLoading || (this.strict && this.$v.repeat.$error) || (this.payload.options.handoverToHeir && !this.payload.options.heir);
    },
  },
  mounted() {
    this.$v.$touch();
  },
  methods: {
    async remove() {
      this.payload.id = this.account._id;

      this.$emit("remove", this.payload);
    },
    onHide() {
      this.$emit("onHide");
    },
  },
};
</script>
